var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance}},[_c('div',{class:[`${_vm.$appPrefix}-tab-module`]},[_c('module-list',{attrs:{"modules":_vm.instance.__children.slice(),"isInEditMode":_vm.$store.page.isInEditMode,"lang":_vm.$store.ui.appCurrentLanguage,"country":_vm.$store.ui.appCurrentLCountry}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }